import { cn } from "@/lib/utils";
import * as React from "react";

const Input = React.forwardRef<
  HTMLInputElement,
  {
    placeholder: string;
    icon?: React.ReactNode;
    size?: "medium" | "large";
    className?: string;
    disabled?: boolean;
    isError?: boolean;
  } & Omit<React.ComponentProps<"input">, "size">
>((props, ref) => {
  const {
    icon,
    size = "medium",
    className,
    placeholder,
    isError = false,
    disabled = false,
    ...rest
  } = props;
  return (
    <div
      className={cn(
        "flex w-full h-full px-3 py-2 rounded-[4px] bg-white border items-center gap-1 focus-within:shadow-input-focus",
        { "border-red-500 shadow-input-error": isError },
        {
          "border-neutral-100 hover:border-neutral-200 active:border-neutral-300 focus-within:border-neutral-300":
            !isError,
        },
        { "opacity-50 cursor-not-allowed": disabled },
        className,
      )}
    >
      {icon}
      <input
        ref={ref}
        type="text"
        placeholder={placeholder}
        disabled={disabled}
        className={cn(
          "w-full outline-none border-none focus:ring-0 focus:outline-none hover:outline-none active:outline-none overflow-x-hidden text-ellipsis font-feature-settings-ss10 placeholder:text-neutral-400 text-primary",
          {
            "label-2-regular": size === "large",
            "caption-2-regular": size === "medium",
          },
        )}
        {...rest}
      />
    </div>
  );
});

Input.displayName = "Input";

export default Input;
